import { Box, Button, DialogProps } from "@mui/material";
import BasicModal from "./modal/BasicModal";
import { useState } from "react";

interface Props extends DialogProps {
  onClose: () => void;
  onSubmit: () => void; // Function to call API or handle actions
  title?: string;
  content?: string; // Dynamic content
}

function ConfirmationModal({
  onClose,
  onSubmit,
  title = "Confirmation",
  content = "Do you want to proceed?",
  ...props
}: Props) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (loading) return; // Prevent duplicate calls
    setLoading(true);
    await onSubmit();
    setLoading(false);
    onClose(); // Close modal after API call
  };
  return (
    <BasicModal
      onClose={onClose}
      //   onSubmit={onSubmit}
      isLoader={loading}
      loadingTitle="Loading..."
      title={title}
      content={<Box>{content}</Box>}
      actions={
        <>
          <Button
            color="error"
            variant="outlined"
            onClick={onClose}
            sx={{ textTransform: "capitalize" }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ textTransform: "capitalize" }}
            type="submit"
            color="success"
            onClick={handleConfirm} // Prevents duplicate API calls
            disabled={loading}
          >
            {loading ? "Processing..." : "Confirm"}
          </Button>
        </>
      }
      {...props}
    />
  );
}

export default ConfirmationModal;
